"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Publish = _interopRequireDefault(require("@material-ui/icons/Publish"));

var _styles = require("@material-ui/core/styles");

var _ui = require("@probeton/ui");

var _pocUi = require("@solar/poc-ui");

var _solarReact = require("@solar/solar-react");

var _ACLHeader = _interopRequireDefault(require("../ACLHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    editDescriptionButtons: {
      marginLeft: 24,
      marginRight: 24,
      paddingBottom: 12
    },
    uploadPdfButton: {
      margin: 12
    },
    uploadSpinner: {
      margin: 12
    },
    uploadDialogRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
});

var CertificateBenor = function CertificateBenor(_ref) {
  var certificate = _ref.certificate,
      _addTechnicalSheet = _ref.addTechnicalSheet,
      addRestrictedTechnicalSheet = _ref.addRestrictedTechnicalSheet,
      _editDescription = _ref.editDescription,
      editAcl = _ref.editAcl,
      getAWSSignedUrl = _ref.getAWSSignedUrl,
      setPdfOpen = _ref.setPdfOpen,
      labels = _ref.labels;
  var technicalSheet = certificate.technicalSheet,
      restrictedTechnicalSheet = certificate.restrictedTechnicalSheet,
      acl = certificate.acl;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels["public"]), /*#__PURE__*/_react["default"].createElement(TechnicalSheetItem, {
    technicalSheet: technicalSheet,
    addTechnicalSheet: function addTechnicalSheet(document) {
      return _addTechnicalSheet(document);
    },
    getAWSSignedUrl: getAWSSignedUrl,
    setPdfOpen: setPdfOpen,
    versionLabel: labels.version,
    uploadLabel: labels.newVersion,
    uploadLabels: labels
  }), acl != null && /*#__PURE__*/_react["default"].createElement(_ACLHeader["default"], {
    header: labels.restricted,
    acl: acl.restrictedTechnicalSheet,
    onAclChange: function onAclChange(restrictedTechnicalSheetAcl) {
      return editAcl(_objectSpread(_objectSpread({}, acl), {}, {
        restrictedTechnicalSheet: restrictedTechnicalSheetAcl
      }));
    },
    labels: {
      acl: labels.acl
    }
  }), /*#__PURE__*/_react["default"].createElement(TechnicalSheetItem, {
    technicalSheet: restrictedTechnicalSheet,
    addTechnicalSheet: function addTechnicalSheet(document) {
      return addRestrictedTechnicalSheet(document);
    },
    getAWSSignedUrl: getAWSSignedUrl,
    setPdfOpen: setPdfOpen,
    versionLabel: labels.version,
    uploadLabel: labels.newVersion,
    uploadLabels: labels
  }), /*#__PURE__*/_react["default"].createElement(EditDescriptionSection, {
    certificate: certificate,
    editDescription: function editDescription(description) {
      return _editDescription(description);
    },
    labels: labels
  }));
};

var TechnicalSheetItem = function TechnicalSheetItem(_ref2) {
  var technicalSheet = _ref2.technicalSheet,
      addTechnicalSheet = _ref2.addTechnicalSheet,
      getAWSSignedUrl = _ref2.getAWSSignedUrl,
      setPdfOpen = _ref2.setPdfOpen,
      versionLabel = _ref2.versionLabel,
      uploadLabel = _ref2.uploadLabel,
      uploadLabels = _ref2.uploadLabels;
  var document = technicalSheet != null ? technicalSheet.latest : null;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, document != null && /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
    label: "".concat(versionLabel, " ").concat(document.version),
    fileUrl: document.src,
    description: document.fileName,
    interactive: true,
    onClickOpen: function onClickOpen() {
      return setPdfOpen(document.src);
    },
    onClickDownloadFile: function onClickDownloadFile() {
      return window.open(document.src, '__blank');
    }
  })), /*#__PURE__*/_react["default"].createElement(UploadTechnicalSheet, {
    onUpload: function onUpload(nextDocument) {
      return addTechnicalSheet(nextDocument);
    },
    getAWSSignedUrl: getAWSSignedUrl,
    uploadLabel: uploadLabel,
    uploadLabels: uploadLabels
  }));
};

var UploadTechnicalSheet = function UploadTechnicalSheet(_ref3) {
  var onUpload = _ref3.onUpload,
      getAWSSignedUrl = _ref3.getAWSSignedUrl,
      uploadLabel = _ref3.uploadLabel,
      uploadLabels = _ref3.uploadLabels;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenDialog = _useState2[0],
      setIsOpenDialog = _useState2[1];

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(UploadTechnicalSheetDialog, {
    isOpen: isOpenDialog,
    onUpload: onUpload,
    onClose: function onClose() {
      return setIsOpenDialog(false);
    },
    getAWSSignedUrl: getAWSSignedUrl,
    labels: uploadLabels
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.AlignRight, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.uploadPdfButton,
    onClick: function onClick() {
      return setIsOpenDialog(true);
    }
  }, uploadLabel)));
};

var UploadTechnicalSheetDialog = function UploadTechnicalSheetDialog(_ref4) {
  var isOpen = _ref4.isOpen,
      onUpload = _ref4.onUpload,
      onClose = _ref4.onClose,
      getAWSSignedUrl = _ref4.getAWSSignedUrl,
      labels = _ref4.labels;

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      document = _useState4[0],
      setDocument = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      version = _useState6[0],
      setVersion = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      notes = _useState8[0],
      setNotes = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      progress = _useState10[0],
      setProgress = _useState10[1];

  var fileUploadRef = (0, _react.useRef)();
  var classes = useStyles();

  var clearForm = function clearForm() {
    setDocument(null);
    setVersion('');
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    "aria-labelledby": "upload-technical-sheet-dialog",
    fullWidth: true,
    maxWidth: "md",
    open: isOpen,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, labels.newVersion), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.uploadDialogRow
  }, document == null ? /*#__PURE__*/_react["default"].createElement(_core.Typography, null, labels.addPdf) : /*#__PURE__*/_react["default"].createElement(_core.Typography, null, document.fileName), document == null && progress === 0 && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "technical-sheet-upload-button",
    "aria-controls": "technical-sheet-upload-button",
    "aria-haspopup": "true",
    onClick: function onClick() {
      return fileUploadRef.current.startUpload();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Publish["default"], null)), document == null && progress > 0 && /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    value: progress,
    className: classes.uploadSpinner
  })), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "version",
    id: "version",
    fullWidth: true,
    margin: "normal",
    label: labels.version,
    required: true,
    autoFocus: true,
    onChange: function onChange(event) {
      return setVersion(event.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "notes",
    id: "notes",
    fullWidth: true,
    margin: "normal",
    label: labels.description,
    autoFocus: true,
    onChange: function onChange(event) {
      return setNotes(event.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "flat",
    color: "primary",
    onClick: function onClick() {
      clearForm();
      onClose();
    }
  }, labels.cancel), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "flat",
    color: "primary",
    disabled: document == null || version === '',
    onClick: function onClick() {
      onUpload(_objectSpread(_objectSpread({}, document), {}, {
        version: version,
        notes: notes
      }));
      clearForm();
      onClose();
    }
  }, labels.confirm)), /*#__PURE__*/_react["default"].createElement(_ui.FileUpload, {
    ref: fileUploadRef,
    allowedFileTypes: ['.pdf'],
    getAWSSignedUrl: getAWSSignedUrl('covers') // TODO: Change S3 bucket name
    ,
    onComplete: function onComplete(_ref5) {
      var fileName = _ref5.name,
          src = _ref5.url,
          type = _ref5.type;
      setProgress(0);
      setDocument({
        fileName: fileName,
        src: src,
        type: type
      });
    },
    onChange: function onChange(_ref6) {
      var nextProgress = _ref6.progress;
      return setProgress(nextProgress);
    }
  }));
};

var EditDescriptionSection = function EditDescriptionSection(_ref7) {
  var _certificate$product, _certificate$product2;

  var certificate = _ref7.certificate,
      editDescription = _ref7.editDescription,
      labels = _ref7.labels;

  var _useEditable = (0, _pocUi.useEditable)(['description'], certificate, certificate._id),
      _useEditable2 = _slicedToArray(_useEditable, 4),
      isDirty = _useEditable2[0],
      setEdits = _useEditable2[1],
      merged = _useEditable2[2],
      cancelEdits = _useEditable2[3];

  var classes = useStyles();

  var handlePropChange = function handlePropChange(prop) {
    return function (event) {
      setEdits(_defineProperty({}, prop, event.target.value));
    };
  }; // console.log(certificate.product.description);


  var placeholderText = certificate.types.length > 0 && certificate.types[0].title !== '-' ? certificate.types[0].title : ((_certificate$product = certificate.product) === null || _certificate$product === void 0 ? void 0 : _certificate$product.description) || ((_certificate$product2 = certificate.product) === null || _certificate$product2 === void 0 ? void 0 : _certificate$product2.title);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.searchable), /*#__PURE__*/_react["default"].createElement(_pocUi.EditField, {
    label: labels.decription,
    value: merged.description || placeholderText,
    multiline: true,
    rows: 4,
    rowsMax: 12,
    onChange: handlePropChange('description')
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    justifyContent: "space-between",
    className: classes.editDescriptionButtons
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    disabled: !isDirty,
    onClick: function onClick() {
      return cancelEdits();
    }
  }, labels.cancel), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    disabled: !isDirty,
    onClick: function onClick() {
      return editDescription(merged.description);
    }
  }, labels.save)));
};

var _default = CertificateBenor;
exports["default"] = _default;